/* Sommaire des pages techno : rendre le défilement horizontal utilisable à la souris.

   Une molette n'envoie qu'un delta vertical : sans ce script, un menu qui déborde
   ne bouge pas pour qui n'a pas de pavé tactile. On transpose donc la molette à
   l'horizontale, mais seulement tant que la liste peut encore défiler dans ce
   sens : en bout de course, la page reprend la main et rien n'est piégé.

   Le clic-glisser est également accepté, y compris en partant d'un lien : le
   navigateur voudrait alors déplacer le lien lui-même, on l'en empêche. Il ne
   concerne que la souris : au doigt, le défilement natif est déjà là, avec son
   inertie, et s'en mêler empêchait le tap d'ouvrir le lien.

   Les écouteurs sont posés sur le document plutôt que sur chaque liste : les
   sections rechargées par l'éditeur de thème restent prises en charge sans
   réinitialisation. */
(() => {
  // une page peut contenir deux sommaires, donc deux fois la balise script :
  // les écouteurs ne doivent être posés qu'une fois
  if (window.technoSummaryScroll) return;
  window.technoSummaryScroll = true;

  const SELECTOR = '.techno-summary__row';
  // en dessous, on considère que c'est un clic et non un glissé : un curseur un
  // peu tremblant sur un lien doit continuer à naviguer
  const DRAG_THRESHOLD = 6;

  const scrollableList = (target) => {
    const list = target instanceof Element ? target.closest(SELECTOR) : null;
    if (!list) return null;
    return list.scrollWidth > list.clientWidth ? list : null;
  };

  document.addEventListener(
    'wheel',
    (evt) => {
      const list = scrollableList(evt.target);
      if (!list) return;

      const delta = Math.abs(evt.deltaY) > Math.abs(evt.deltaX) ? evt.deltaY : evt.deltaX;
      if (!delta) return;

      const max = list.scrollWidth - list.clientWidth;
      const atStart = delta < 0 && list.scrollLeft <= 0;
      const atEnd = delta > 0 && list.scrollLeft >= max;
      if (atStart || atEnd) return;

      evt.preventDefault();
      list.scrollLeft = Math.min(max, Math.max(0, list.scrollLeft + delta));
    },
    { passive: false }
  );

  let drag = null;

  // un lien est « déplaçable » par défaut : sans ça, tirer dessus lance le
  // glisser-déposer natif du navigateur au lieu de faire défiler le menu
  document.addEventListener('dragstart', (evt) => {
    if (evt.target instanceof Element && evt.target.closest(SELECTOR)) evt.preventDefault();
  });

  document.addEventListener('pointerdown', (evt) => {
    // le tactile défile déjà tout seul : capturer son pointeur détournait le
    // clic qui suit, et le lien ne s'ouvrait plus
    if (evt.pointerType !== 'mouse') return;
    if (evt.button !== 0) return;
    const list = scrollableList(evt.target);
    if (!list) return;
    drag = { list, pointerId: evt.pointerId, startX: evt.clientX, startLeft: list.scrollLeft, moved: false };
    // la liste garde la main sur le pointeur, même quand il passe sur un lien
    try {
      list.setPointerCapture(evt.pointerId);
    } catch (error) {
      // navigateur sans capture de pointeur : le glissé reste utilisable
    }
  });

  document.addEventListener('pointermove', (evt) => {
    if (!drag) return;
    const distance = evt.clientX - drag.startX;
    if (!drag.moved && Math.abs(distance) < DRAG_THRESHOLD) return;
    drag.moved = true;
    drag.list.classList.add('is-dragging');
    drag.list.scrollLeft = drag.startLeft - distance;
  });

  const endDrag = () => {
    if (!drag) return;
    const dragged = drag.moved;
    drag.list.classList.remove('is-dragging');
    try {
      drag.list.releasePointerCapture(drag.pointerId);
    } catch (error) {
      // rien à relâcher
    }
    drag = null;

    // un glissé ne doit pas suivre le lien relâché sous le curseur
    if (!dragged) return;
    const swallowClick = (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
    };
    document.addEventListener('click', swallowClick, { capture: true, once: true });
    setTimeout(() => document.removeEventListener('click', swallowClick, { capture: true }), 0);
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
})();
